/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ score: NonNullable<unknown> }} Directory_Submit_Enrich_Result_GeoInputs */

const en_directory_submit_enrich_result_geo = /** @type {(inputs: Directory_Submit_Enrich_Result_GeoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`GEO ${i?.score}/100`)
};

const zh_directory_submit_enrich_result_geo = /** @type {(inputs: Directory_Submit_Enrich_Result_GeoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`GEO ${i?.score}/100`)
};

/**
* | output |
* | --- |
* | "GEO {score}/100" |
*
* @param {Directory_Submit_Enrich_Result_GeoInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_result_geo = /** @type {((inputs: Directory_Submit_Enrich_Result_GeoInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Result_GeoInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_result_geo(inputs)
	return zh_directory_submit_enrich_result_geo(inputs)
});
export { directory_submit_enrich_result_geo as "directory.submit.enrich.result.geo" }